import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const FETCH_EMPLOYEES_REQUEST = "FETCH_EMPLOYEES_REQUEST";
export const FETCH_EMPLOYEES_SUCCESS = "FETCH_EMPLOYEES_SUCCESS";
export const FETCH_EMPLOYEES_FAILURE = "FETCH_EMPLOYEES_FAILURE";

export const UPDATE_EMPLOYEE_REQUEST = "UPDATE_EMPLOYEE_REQUEST";
export const UPDATE_EMPLOYEE_SUCCESS = "UPDATE_EMPLOYEE_SUCCESS";
export const UPDATE_EMPLOYEE_FAILURE = "UPDATE_EMPLOYEE_FAILURE";

export const UPDATE_EMPLOYEE_STATUS_REQUEST = "UPDATE_EMPLOYEE_STATUS_REQUEST";
export const UPDATE_EMPLOYEE_STATUS_SUCCESS = "UPDATE_EMPLOYEE_STATUS_SUCCESS";
export const UPDATE_EMPLOYEE_STATUS_FAILURE = "UPDATE_EMPLOYEE_STATUS_FAILURE";

export const fetchEmployees = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_EMPLOYEES_REQUEST });
    const token = localStorage.getItem("token");
    //fetched employee here
    try {
      const response = await axios.get(`${BASE_URL}/v1/api/getAllEmployee`, {
        headers: { authorization: token },
      });

     
      // Fetch shifts
      const shiftRes = await axios.get(`${BASE_URL}/v1/api/public/getShifts`);
      const shifts = shiftRes.data?.data || [];

      // Map office and shift names into employees
      const employeesWithDetails = response.data.data.map((emp) => {
        const shiftId = emp.shift_id ?? emp.shift;

        const shift = shifts.find((s) => s.id === Number(shiftId));
        return {
          ...emp,
          shift_id: shiftId ? Number(shiftId) : null,
          shift_name: shift?.name || "-",
        };
      });
      dispatch({
        type: FETCH_EMPLOYEES_SUCCESS,
        payload: employeesWithDetails,
      });
    } catch (error) {
      dispatch({
        type: FETCH_EMPLOYEES_FAILURE,
        payload: error.response?.data?.message || error.message,
      });
      toast.error("Failed to fetch employees");
    }
  };
};

export const updateEmployee = (employeeData) => {
  return async (dispatch) => {
    const token = localStorage.getItem("token");

    dispatch({ type: UPDATE_EMPLOYEE_REQUEST });

    try {
      const res = await axios.post(
        `${BASE_URL}/v1/api/updateEmployee`,
        employeeData,
        {
          headers: {
            authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      dispatch({ type: UPDATE_EMPLOYEE_SUCCESS });
      toast.success("Employee updated successfully");
      return res.data;
    } catch (err) {
      dispatch({
        type: UPDATE_EMPLOYEE_FAILURE,
        payload: err.response?.data?.message || "Failed to update employee",
      });
      toast.error(err.response?.data?.message || "Failed to update employee");
      throw err;
    }
  };
};

export const updateEmployeeStatus = (user_id, status) => async (dispatch) => {
  dispatch({ type: UPDATE_EMPLOYEE_STATUS_REQUEST });
  try {
    const token = localStorage.getItem("token"); // or wherever you store auth
    await axios.post(
      `${BASE_URL}/v1/api/update-user-status`,
      { user_id, status },
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({
      type: UPDATE_EMPLOYEE_STATUS_SUCCESS,
      payload: { user_id, status },
    });
  } catch (error) {
    dispatch({ type: UPDATE_EMPLOYEE_STATUS_FAILURE, payload: error.message });
  }
};
